export class MoleculePanelOverviewHeaderMultiDeleteDatabaseActionComponent {
    public templateUrl = require('./multi-delete-database-action.html?external');
}
